<script lang="ts" setup>
interface Props {
  title: string;
  description: string;
}

defineProps<Props>();
</script>

<template>
  <div>
    <h2
      style="
        margin-bottom: 0.375rem;
        color: var(--ch-black);
        font-size: var(--font-lg);
        font-weight: 500;
      "
    >
      {{ title }}
    </h2>
    
    <p style="margin: 0; color: var(--ch-border-grey); font-size: 0.8125rem;">
      {{ description }}
    </p>
  </div>
</template>